import React from 'react'
import debounce from 'debounce-promise'
import { SelectAsync, Icon } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'
import { useIntl } from 'react-intl'

export const SupplierSelect = ({ value, onChange, searchLanguageId = null, supplierTypeIds = [], required, label='Supplier', ...props }) => {
  const supplier = value
  const { formatDate } = useIntl()
  return (
    <SelectAsync
      key="supplierSelect"
      required={required}
      formatOptionLabel={({ value, label, data }) => {
        if (!data) {
          return <span>{ label }</span>
        }

        const { firstname, lastname, priorities = [], status, availability = [] } = data
        const collections = priorities.map(({ slug }) => slug)
        const timestamp = Math.floor(Date.now() / 1000)
        const unavailable = availability.find(({ dateStart, dateEnd }) => parseInt(dateStart) < timestamp && parseInt(dateEnd) > timestamp)

        const title = availability.map(({ dateStart, dateEnd, message }) => (
          `${formatDate(new Date(dateStart * 1000))} - ${formatDate(new Date(dateEnd * 1000))} - ${message}`
        )).join("\n")

        return (
          <div title={title} className={unavailable ? 'bg-red-50' : ''}>
            <div className="flex items-center space-x-2 text-xs">
              <i
                className={classNames('block rounded-full w-2 h-2', unavailable ? 'bg-negative' : 'bg-positive')}
                title={unavailable ? 'Unavailable' : 'Available'}
              />

              { collections.includes('voicestar') &&
                <Icon icon={['fas', 'star']} className="text-primary fa-fw" title="Accepted standard rates ✔" />
              }

              { collections.includes('custom_rates') &&
                <Icon icon={['fas', 'funnel-dollar']} className="text-purple-600 fa-fw" title="Has one or more custom rates ✔" />
              }

              { collections.includes('recommended') &&
                <Icon icon={['fas', 'star']} className="text-yellow-400 fa-fw" title="Recommended Voice Talent" />
              }

              <div className="font-sm font-medium">{ label }</div>
            </div>

            <div className="flex text-xs space-x-1 truncate">
              <span>{ firstname }</span>
              <span>{ lastname }</span>
            </div>
          </div>
        )
      }}
      value={supplier}
      onChange={(data) => data ? onChange(!!props.isMulti ? data : data.data) : undefined}
      options={[]}
      label={label}
      placeholder="Search for ID, name, e-mail or notes"
      noOptionsMessage={({ inputValue }) => (inputValue) ? `No supplier found for '${inputValue}'` : 'No supplier found'}
      loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
      cacheOptions
      defaultOptions
      isClearable
      loadOptions={ props?.loadOptions ? props?.loadOptions :
        debounce((query) => {
          const params = new URLSearchParams({ pageSize: 500, includeRelations: 1 })

          if (searchLanguageId) {
            params.append('search[language]', searchLanguageId)
            params.append('search[language-proficiency]', [1, 2, 3])
          }

          if (query.length > 0) {
            params.append('search[query]', query)
          }

          if (supplierTypeIds?.length > 0) {
            params.append('search[type]', supplierTypeIds)
          }

          params.append('search[status]', '2,4')

          return fetch(`/rest/v2/supplier?${params.toString()}`)
            .then((response) => response.json())
            .then((data) => data.map((supplier) => ({ value: supplier.uid, label: supplier.userid, data: supplier })))
        }, 250)
      }
      {...props}
    />
  )
}

export default SupplierSelect
